import { useShoppingCart } from '@hooks/cart/useShoppingCart';
import { useProductPricing } from '@monofront/business/hooks';
import { getCurrentProductQuantity } from '@monofront/business/utils';
import { IProduct } from '@monofront/types';

const useProductComputedPricing = (product: IProduct) => {
  const { shoppingCart } = useShoppingCart();

  const currentProductQuantity = getCurrentProductQuantity(
    product,
    shoppingCart.products,
  );

  return useProductPricing(product, currentProductQuantity);
};

export default useProductComputedPricing;
